export const getUrlWithoutParams = (url: string): string => {
  const clearUrl = url.includes("classwork")
    ? "classwork"
    : url.split("/").reverse()[0];
  return clearUrl;
};
